/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
export const RevoGrid = /*@__PURE__*/ createReactComponent('revo-grid');
export const RevogrData = /*@__PURE__*/ createReactComponent('revogr-data');
export const RevogrEdit = /*@__PURE__*/ createReactComponent('revogr-edit');
export const RevogrHeader = /*@__PURE__*/ createReactComponent('revogr-header');
export const RevogrOverlaySelection = /*@__PURE__*/ createReactComponent('revogr-overlay-selection');
export const RevogrScrollVirtual = /*@__PURE__*/ createReactComponent('revogr-scroll-virtual');
export const RevogrViewport = /*@__PURE__*/ createReactComponent('revogr-viewport');
export const RevogrViewportScroll = /*@__PURE__*/ createReactComponent('revogr-viewport-scroll');
//# sourceMappingURL=revogrid.js.map